// extracted by mini-css-extract-plugin
export var address = "Office-module--address--9e2c1";
export var appointment = "Office-module--appointment--17014";
export var contactInformation = "Office-module--contact-information--226dc";
export var images = "Office-module--images--cd4d9";
export var openingHours = "Office-module--opening-hours--87c2b";
export var root = "Office-module--root--bb816";
export var titleDescription = "Office-module--title-description--e21ab";